// extracted by mini-css-extract-plugin
export default {"onBoardingSelect":"styles_onBoardingSelect__aBY3p","onBoardingDropdownPopUp":"styles_onBoardingDropdownPopUp__vAn1s"};